import { useTranslation } from "next-i18next";
import { SettingsSubscriptionButton } from "../../../SettingsSubscriptionButton/SettingsSubscriptionButton";

interface ChangePaymentDetailsButtonProps {
  isLoading: boolean;
  onClick: () => void;
}

export const ChangePaymentDetailsButton = ({
  isLoading,
  onClick,
}: ChangePaymentDetailsButtonProps) => {
  const { t } = useTranslation("translations");

  return (
    <SettingsSubscriptionButton
      loading={isLoading}
      disabled={isLoading}
      variant="plain"
      onClick={onClick}
    >
      {t("web_payment_details_edit_payment_details")}
    </SettingsSubscriptionButton>
  );
};
